import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { metadata, studies, utils } from 'ohif-core';
import uniq from 'lodash/uniq';

import { withRouter } from 'react-router-dom';

import ConnectedViewer from '../connectedComponents/ConnectedViewer';
import { extensionManager } from './../App.js';
import qs from 'query-string';
import { apis } from '../api/index.js';
import { message } from 'antd';
import './AiViewerRouting.css';
import icon04 from '../upload/imgs/icon04.png';
import Loading from '../components/Loading/Loading.js';
import ImageError from '../components/Error/ImageError.js';
import { aesMinEncrypt } from '../utils';

const { OHIFStudyMetadata } = metadata;
const { retrieveStudiesMetadata } = studies;
const { studyMetadataManager, updateMetaDataManager } = utils;

class AiViewerRouting extends Component {
  static propTypes = {
    history: PropTypes.object,
    setAIProductDetailInfo: PropTypes.func,
  };
  state = {
    studies: null,
    studyUids: [],
    error: null,
    resource: null,
    isChrome: true,
    userInfo: window.store.getState().api.user.info,
  };

  async componentDidMount() {
    const isPrewarning = qs.parse(window.location.search).prewarning;
    if (isPrewarning) {
      let [userInfo, password] = [{}, 'P9YNSz'];
      password = aesMinEncrypt(password);
      const post = { accountName: 'yujing', password };
      await apis.dcm4cheepath().then(pathRes => {
        userInfo.path = pathRes.wado;
      });
      await apis.login(post).then(res => {
        if (res.code === '0') userInfo = res.data;
      });
      await apis.dcm4cheeType().then(resType => {
        userInfo.dcmType = resType.type;
      });
      await apis.dcm4cheepath().then(res => {
        userInfo.path = res.wado;
      });
      this.setState({ userInfo });
    }
    if (window.navigator.userAgent.indexOf('Chrome') !== -1) {
      if (window.navigator.webkitPersistentStorage) {
        const state = window.store.getState();
        const params = qs.parse(window.location.search);
        const objects = params.objects ? JSON.parse(params.objects) : [];
        const server = state.servers.servers.find(s => s.active);
        const studyUids = uniq(objects.map(obj => obj.StudyUid), 'StudyUid');
        const seriesUids = uniq(objects.map(obj => obj.SeriesUid), 'SeriesUid');
        const objectUids = uniq(objects.map(obj => obj.ObjectUid), 'ObjectUid');
        if (studyUids.length) {
          const type = params.type;
          const post = {
            study_uid: studyUids[0],
            series_uid: seriesUids[0],
            sop_instance_uid: objectUids[0],
            aiProductType: type,
          };
          apis
            .dicomBy3Uid(studyUids[0], seriesUids[0], objectUids[0])
            .then(res => {
              if (res.code === '0')
                this.setState({ applicationInfo: res.data[0] });
            });
          await apis.getAiResult(post).then(result => {
            if (result.code === '0') {
              this.setState({ resource: result.data });
            } else {
              if (result.code === '1009') {
                this.props.history.push('/login');
              }
              message.error(result.message, 2);
            }
          });
          // await apis.dcm4cheepath().then(res => {
          //   server.qidoRoot = res.rs;
          //   server.wadoRoot = res.rs;
          //   server.wadoUriRoot = res.wado;
          // });
          apis
            .dicomBy3Uid(studyUids[0], seriesUids[0], objectUids[0])
            .then(res => {
              if (res.code === '0')
                this.setState({ dicomInfoBy3Id: res.data[0] });
            });
          try {
            const studies = await retrieveStudiesMetadata(
              server,
              studyUids,
              seriesUids,
              objectUids
            );
            studyMetadataManager.purge();
            // Map studies to new format, update metadata manager?
            const updatedStudies = studies.map(study => {
              study.seriesList = study.seriesList.filter(series => {
                if (seriesUids.includes(series.seriesInstanceUid)) {
                  series.instances = series.instances.filter(inst =>
                    objectUids.includes(inst.sopInstanceUid)
                  );
                  return true;
                }
                return false;
              });
              const studyMetadata = new OHIFStudyMetadata(
                study,
                study.studyInstanceUid
              );
              const sopClassHandlerModules =
                extensionManager.modules['sopClassHandlerModule'];
              study.displaySets =
                study.displaySets ||
                studyMetadata.createDisplaySets(sopClassHandlerModules);
              studyMetadata.setDisplaySets(study.displaySets);
              // Updates WADO-RS metaDataManager
              updateMetaDataManager(study);
              studyMetadataManager.add(studyMetadata);
              return study;
            });
            this.setState({ studies: updatedStudies, studyUids });
          } catch (error) {
            this.setState({ error });
          }
        } else {
          this.setState({ error: '没有找到图像UID' });
        }
      } else {
        this.setState({ isChrome: false });
      }
    } else {
      this.setState({ isChrome: false });
    }
  }

  render() {
    if (!this.state.isChrome) {
      return (
        <div className="use-chrome">
          <div className="img">
            <img src={icon04} alt="" />
          </div>
          <div className="tip">
            当前浏览器不支持热力图展示，请前往
            <a
              href="https://www.google.cn/intl/zh-CN/chrome/"
              target="_blank"
              rel="noopener noreferrer"
            >
              下载Chrome浏览器
            </a>
          </div>
        </div>
      );
    } else if (this.state.error) {
      console.log('error3');
      return (
        <ImageError title="因影像格式有异常，无法查看。如需帮助，请联系在线客服" />
      );
    } else if (!this.state.studies) {
      return <Loading />;
    } else if (!this.state.resource) {
      return <Loading />;
    }
    return (
      <ConnectedViewer
        studies={this.state.studies}
        studyInstanceUids={this.state.studyUids}
        resource={this.state.resource}
        history={this.props.history}
        userInfo={this.state.userInfo}
        dicomInfoBy3Uid={this.state.applicationInfo}
      />
    );
  }
}

export default withRouter(AiViewerRouting);
